import React from "react";
import { useOutletContext } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ClientProfile() {
  const { user } = useAuth();
  const { project } = useOutletContext();

  return (
    <div className="max-w-2xl" data-testid="client-profile">
      <div className="label text-[color:var(--atech-copper)] mb-2">Your account</div>
      <h2 className="font-display text-3xl text-white mb-8">Profile</h2>
      <div className="card-surface p-8 space-y-5">
        <Row k="Name" v={user?.name || "—"} />
        <Row k="Email" v={user?.email || "—"} />
        <Row k="Role" v="Client" />
        <Row k="Client organisation" v={project?.client?.name || "—"} />
      </div>
      <p className="text-xs text-[color:var(--atech-text-muted)] mt-6">
        To update these details, please contact A-Tech directly.
      </p>
    </div>
  );
}

const Row = ({ k, v }) => (
  <div className="flex items-center justify-between gap-4 border-b border-white/5 pb-4 last:border-b-0 last:pb-0">
    <span className="label">{k}</span>
    <span className="text-sm text-[color:var(--atech-text)] text-right">{v}</span>
  </div>
);
